// src/constants/landmarkResources.js
// 👇 清空默认背景
export const DEFAULT_BG_IMAGE = "";

// 👇 所有地标背景全部清空
export const LANDMARK_RESOURCES = {
  1: { bgImage: "" },
  2: { video: "", bgImage: "", videoPoster: "" },
  3: { video: "", bgImage: "", videoPoster: "" },
  4: { video: "", bgImage: "", videoPoster: "" },
  5: { video: "", bgImage: "", videoPoster: "" },
  6: { video: "", bgImage: "", videoPoster: "" },
  7: { video: "", bgImage: "", videoPoster: "" },
  8: { video: "", bgImage: "", videoPoster: "" },
};

// 名称映射（不用动）
const LANDMARK_NAME_MAP = [
  { keywords: ["蒙马特", "圣心堂", "montmartre"], resource: LANDMARK_RESOURCES[1] },
  { keywords: ["塞纳", "seine"], resource: LANDMARK_RESOURCES[2] },
  { keywords: ["圣母院", "notre"], resource: LANDMARK_RESOURCES[3] },
  { keywords: ["卢浮宫", "louvre"], resource: LANDMARK_RESOURCES[4] },
  { keywords: ["凡尔赛", "versailles"], resource: LANDMARK_RESOURCES[5] },
  { keywords: ["香榭丽舍", "champselysees"], resource: LANDMARK_RESOURCES[6] },
  { keywords: ["埃菲尔", "铁塔", "eiffel"], resource: LANDMARK_RESOURCES[7] },
  { keywords: ["巴黎", "全景", "终章"], resource: LANDMARK_RESOURCES[8] },
];

export function getLandmarkResource(landmark) {
  if (!landmark) {
    return { video: "", bgImage: DEFAULT_BG_IMAGE, videoPoster: DEFAULT_BG_IMAGE };
  }

  if (landmark.id !== undefined && LANDMARK_RESOURCES[landmark.id]) {
    return {
      video: "",
      videoPoster: DEFAULT_BG_IMAGE,
      ...LANDMARK_RESOURCES[landmark.id],
    };
  }

  const name = String(landmark.name || "").toLowerCase();
  const matched = LANDMARK_NAME_MAP.find((item) =>
    item.keywords.some((kw) => name.includes(kw.toLowerCase()))
  );

  if (matched?.resource) {
    return {
      video: "",
      videoPoster: DEFAULT_BG_IMAGE,
      ...matched.resource,
    };
  }

  return { video: "", bgImage: DEFAULT_BG_IMAGE, videoPoster: DEFAULT_BG_IMAGE };
}

// ====================== 🔥 你的专属皮肤配置 ======================
export const HOME_SKINS = [
  {
    id: "eiffel-tower",
    name: "埃菲尔铁塔",
    bgUrl: "/eiffel-tower.jpg",
    needShards: 0,
    isDefault: true
  },
  {
    id: "notre-dame",
    name: "巴黎圣母院",
    bgUrl: "/notre-dame.jpg",
    needShards: 4,
  },
  {
    id: "versailles",
    name: "凡尔赛宫",
    bgUrl: "/versailles.jpg",
    needShards: 4,
  },
  {
    id: "highland",
    name: "高地",
    bgUrl: "/highland.jpg",
    needShards: 4,
  },
  {
    id: "louvre",
    name: "卢浮宫",
    bgUrl: "/louvre.jpg",
    needShards: 4,
  },
  {
    id: "seine",
    name: "塞纳河",
    bgUrl: "/seine.jpg",
    needShards: 4,
  },
  {
    id: "champs",
    name: "香榭",
    bgUrl: "/champs.png",
    needShards: 4,
  }
];

export const SHARD_CONFIG = {
  minDrop: 1,
  maxDrop: 2,
  dropEvents: ["learn_complete", "review_complete", "spelling_complete", "check_in"]
};

// ====================== 🔥 地标轮播完整数据（已加视频+免费配置） ======================
export const LANDMARK_LIST = [
  {
    id: 1,
    name: "蒙马特高地",
    frenchName: "Montmartre",
    bgUrl: "/highland.jpg",
    videoUrl: "/videos/高地——塞纳河畔.mp4",
    needShards: 0,
    isDefault: true,
  },
  {
    id: 2,
    name: "塞纳河",
    frenchName: "La Seine",
    bgUrl: "/seine.jpg",
    videoUrl: "/videos/塞纳河——巴黎.mp4",
    needShards: 4,
  },
  {
    id: 3,
    name: "巴黎圣母院",
    frenchName: "Notre-Dame de Paris",
    bgUrl: "/notre-dame.jpg",
    videoUrl: "/videos/巴黎圣母——卢浮宫.mp4",
    needShards: 4,
  },
  {
    id: 4,
    name: "卢浮宫",
    frenchName: "Musée du Louvre",
    bgUrl: "/louvre.jpg",
    videoUrl: "/videos/卢浮宫——凡尔赛.mp4",
    needShards: 4,
  },
  {
    id: 5,
    name: "凡尔赛宫",
    frenchName: "Château de Versailles",
    bgUrl: "/versailles.jpg",
    videoUrl: "/videos/凡尔赛——香榭.mp4",
    needShards: 4,
  },
  {
    id: 6,
    name: "香榭丽舍",
    frenchName: "Avenue des Champs-Élysées",
    bgUrl: "/champs.png",
    videoUrl: "/videos/香榭丽舍——全景.mp4",
    needShards: 4,
  },
  {
    id: 7,
    name: "埃菲尔铁塔",
    frenchName: "La Tour Eiffel",
    bgUrl: "/eiffel-tower.jpg",
    videoUrl: "/videos/想歇尔——巴黎.mp4",
    needShards: 0, // 🔥 永久免费
  },
];